// extracted by mini-css-extract-plugin
module.exports = {"scrollBtn":"scrollBtn___1L802","hidden":"hidden___2OchZ"};